import React, { useState } from "react"
import FormCreatePendingTask from "./FormCreatePendingTask.controller"
import PendingTaskList from "./PendingTaskList.controller"

const TodoTasks = ({ setTodoTasksLength }) => {
  const [refresh, setRefresh] = useState(false)
  const [lastFinishChangeTaskID, setLastFinishChangeTaskID] = useState(null)
  const [taskIsBeingHidden, setTaskIsBeingHidden] = useState(false)
  const triggerRefresh = () => setRefresh(!refresh)
  return (
    <div className="flex overflow-hidden flex-column gap-4">
      <FormCreatePendingTask
        triggerRefresh={triggerRefresh}
        setLastFinishChangeTaskID={setLastFinishChangeTaskID}
        setTaskIsBeingHidden={setTaskIsBeingHidden}
      />
      <PendingTaskList
        refresh={refresh}
        triggerRefresh={triggerRefresh}
        lastFinishChangeTaskID={lastFinishChangeTaskID}
        setLastFinishChangeTaskID={setLastFinishChangeTaskID}
        taskIsBeingHidden={taskIsBeingHidden}
        setTaskIsBeingHidden={setTaskIsBeingHidden}
        setTodoTasksLength={setTodoTasksLength}
      />
    </div>
  )
}

export default TodoTasks
